import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedArticles() {
  const featuredArticles = getFeaturedArticles();

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-foreground-600 text-sm">编辑团队精选的高质量内容</p>
          </div>
          <Link
            to="/category/wanfa-guize"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.slug} {...article} />
          ))}
        </div>
        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/wanfa-guize"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}